import { CalendarDays, FileText, MapPin, Share } from "lucide-react";
import SectionHeader from "./SectionHeader";

const STEPS = [
  { icon: FileText, title: "Brief", desc: "You share the occasion, audience, date and budget range. We ask what a good day looks like." },
  { icon: CalendarDays, title: "Plan", desc: "We return a concept, budget, run of show, vendor plan and a clear quote." },
  { icon: MapPin, title: "Run It", desc: "We build the event, manage every vendor and run the day on the ground, while the media crew captures it." },
  { icon: Share, title: "Share It", desc: "Highlights, photos and a recap video go out through your channels and our creators, followed by a closing report." },
];

// Content is overridable so other pages (e.g. AI Content Creation) can reuse the steps.
const EventsProcess = ({
  steps = STEPS,
  eyebrow = "How it works",
  title = "From brief to",
  accent = "after-movie.",
  intro,
}) => (
  <section className="ee-section ee-process">
    <div className="container">
      <SectionHeader eyebrow={eyebrow} title={title} accent={accent} intro={intro} />
      <div className="ee-process-grid">
        {steps.map(({ icon: Icon, title, desc }, i) => (
          <article className="ee-process-step" key={title} data-aos="fade-up" data-aos-once="true" data-aos-delay={i * 100}>
            <span className="ee-step-num">0{i + 1}</span>
            <div className="ee-process-copy">
              <h3>{title}</h3>
              <p>{desc}</p>
            </div>
            <Icon className="ee-process-icon" size={27} strokeWidth={1.8} aria-hidden="true" />
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default EventsProcess;
